import { TargetingFiltersEnum } from '@Common/TargetingShared/enum/targeting-filters.enum';
import { FilterTypeTextModel } from '@Common/Filter/models/filter-type-text.model';
import { FilterSectionEnum } from '@Common/Filter/enums/filter-section.enum';
import { FilterTypeCheckboxModel } from '@Common/Filter/models/filter-type-checkbox.model';
import { FilterGroupModel } from '@Common/Filter/models/filter-group.model';
import { ReachFilterModel } from '@Common/TargetingShared/model/reach-filter.model';
import { ReachFilterComponent } from '@Common/TargetingShared/components/ReachFilter/reach-filter.component';
import { StatusFilterModel } from '../components/TargetingResults/StatusFilter/status-filter.model';
import { StatusFilterComponent } from '../components/TargetingResults/StatusFilter/status-filter.component';
import { FilterTypeStreamContentCheckboxModel } from '../components/TargetingResults/StreamContentCheckboxFilter/stream-content-checkbox.model';
import { StreamContentCheckboxFilterComponent } from '../components/TargetingResults/StreamContentCheckboxFilter/stream-content-checkbox-filter.component';
import { TargetingMediaTypeEnum } from '../enums/targeting-media-type.enum';

export class TargetingFilterFactory {

    static createFilter(type: TargetingFiltersEnum):
    FilterTypeTextModel | FilterGroupModel | FilterTypeCheckboxModel | ReachFilterModel | StatusFilterModel {
        switch(type) {
            case TargetingFiltersEnum.contactName:
                return new FilterTypeTextModel(
                    TargetingFiltersEnum.contactName,
                    'Discover.targeting.filter.contactName',
                    [],
                    'Discover.targeting.filter.contactName.placeholder',
                    true,
                    true,
                    undefined,
                    FilterSectionEnum.CONTACT_DETAIL,
                    true,
                    true
                );
            case TargetingFiltersEnum.outletName:
                return new FilterTypeTextModel(
                    TargetingFiltersEnum.outletName,
                    'Discover.targeting.filter.outletName',
                    [],
                    'Discover.targeting.filter.outletName.placeholder',
                    true,
                    true,
                    undefined,
                    FilterSectionEnum.OUTLET_DETAIL,
                    undefined,
                    true
                );
            case TargetingFiltersEnum.jobRole:
                return new FilterTypeCheckboxModel<number>(
                    TargetingFiltersEnum.jobRole,
                    'Discover.targeting.filter.jobRole',
                    [],
                    true,
                    undefined,
                    undefined,
                    undefined,
                    'Discover.targeting.filter.search',
                    FilterSectionEnum.CONTACT_DETAIL,
                    true
                );
            case TargetingFiltersEnum.jobTitle:
                return new FilterTypeTextModel(
                    TargetingFiltersEnum.jobTitle,
                    'Discover.targeting.filter.jobTitle',
                    [],
                    'Discover.targeting.filter.jobTitle.placeholder',
                    false,
                    true,
                    undefined,
                    FilterSectionEnum.CONTACT_DETAIL,
                    undefined,
                    true
                );
            case TargetingFiltersEnum.location:
                return new FilterGroupModel(
                    TargetingFiltersEnum.location,
                    'Discover.targeting.filter.location',
                    FilterSectionEnum.CONTACT_DETAIL,
                    true
                );
            case TargetingFiltersEnum.country:
                return new FilterTypeCheckboxModel<number>(
                    TargetingFiltersEnum.country,
                    'Common.country',
                    [],
                    true,
                    undefined,
                    undefined,
                    undefined,
                    'Discover.targeting.filter.search',
                    undefined,
                    true
                );
            case TargetingFiltersEnum.province:
                return new FilterTypeCheckboxModel<number>(
                    TargetingFiltersEnum.province,
                    'Common.province',
                    [],
                    true,
                    undefined,
                    undefined,
                    undefined,
                    'Discover.targeting.filter.search',
                    undefined,
                    true
                );
            case TargetingFiltersEnum.city:
                return new FilterTypeCheckboxModel<number>(
                    TargetingFiltersEnum.city,
                    'Common.city',
                    [],
                    true,
                    undefined,
                    undefined,
                    undefined,
                    'Discover.targeting.filter.search',
                    undefined,
                    true
                );
            case TargetingFiltersEnum.deliveryStatus:
                return new FilterTypeCheckboxModel<number>(
                    TargetingFiltersEnum.deliveryStatus,
                    'Discover.targeting.filter.deliveryStatus',
                    [],
                    false,
                    undefined,
                    undefined,
                    undefined,
                    'Discover.targeting.filter.search',
                    FilterSectionEnum.CONTACT_DETAIL,
                    false
                );
            case TargetingFiltersEnum.subject:
                return new FilterTypeCheckboxModel<number>(
                    TargetingFiltersEnum.subject,
                    'Discover.targeting.filter.subject',
                    [],
                    true,
                    undefined,
                    undefined,
                    undefined,
                    'Discover.targeting.filter.search',
                    FilterSectionEnum.COVERAGE_PROFILE,
                    true
                );
            case TargetingFiltersEnum.language:
                return new FilterTypeCheckboxModel<string>(
                    TargetingFiltersEnum.language,
                    'Discover.targeting.filter.language',
                    [],
                    true,
                    undefined,
                    undefined,
                    undefined,
                    'Discover.targeting.filter.search',
                    FilterSectionEnum.COVERAGE_PROFILE,
                    true
                );
            case TargetingFiltersEnum.targetAudienceRegion:
                return new FilterGroupModel(
                    TargetingFiltersEnum.targetAudienceRegion,
                    'Discover.targeting.filter.targetAudienceRegion',
                    FilterSectionEnum.COVERAGE_PROFILE,
                    true
                );
            case TargetingFiltersEnum.aocCountry:
                return new FilterTypeCheckboxModel<number>(
                    TargetingFiltersEnum.aocCountry,
                    'Common.country',
                    [],
                    true,
                    undefined,
                    undefined,
                    undefined,
                    'Discover.targeting.filter.search',
                    undefined,
                    true
                );
            case TargetingFiltersEnum.aocProvince:
                return new FilterTypeCheckboxModel<number>(
                    TargetingFiltersEnum.aocProvince,
                    'Common.province',
                    [],
                    true,
                    undefined,
                    undefined,
                    undefined,
                    'Discover.targeting.filter.search',
                    undefined,
                    true
                );
            case TargetingFiltersEnum.aocCity:
                return new FilterTypeCheckboxModel<number>(
                    TargetingFiltersEnum.aocCity,
                    'Common.city',
                    [],
                    true,
                    undefined,
                    undefined,
                    undefined,
                    'Discover.targeting.filter.search',
                    undefined,
                    true
                );
            case TargetingFiltersEnum.mediaMarket:
                return new FilterTypeCheckboxModel<number>(
                    TargetingFiltersEnum.mediaMarket,
                    'Discover.targeting.filter.mediaMarket',
                    [],
                    true,
                    undefined,
                    undefined,
                    undefined,
                    'Discover.targeting.filter.search',
                    undefined,
                    true
                );
            case TargetingFiltersEnum.coverageFocus:
                return new FilterTypeCheckboxModel<string>(
                    TargetingFiltersEnum.coverageFocus,
                    'Discover.targeting.filter.coverageFocus',
                    [],
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    FilterSectionEnum.COVERAGE_PROFILE,
                    true
                );
            case TargetingFiltersEnum.audienceReach:
                return new ReachFilterModel(
                    TargetingFiltersEnum.audienceReach,
                    'Discover.targeting.filter.audienceReach',
                    ReachFilterComponent,
                    FilterSectionEnum.COVERAGE_PROFILE
                );
            case TargetingFiltersEnum.marketSector:
                return new FilterTypeCheckboxModel<string>(
                    TargetingFiltersEnum.marketSector,
                    'Discover.targeting.filter.marketSector',
                    [],
                    true,
                    undefined,
                    undefined,
                    undefined,
                    'Discover.targeting.filter.search',
                    FilterSectionEnum.COVERAGE_PROFILE,
                    true
                );
            case TargetingFiltersEnum.mediaType:
                return new FilterTypeCheckboxModel<TargetingMediaTypeEnum>(
                    TargetingFiltersEnum.mediaType,
                    'Discover.targeting.filter.mediaType',
                    [],
                    true,
                    undefined,
                    undefined,
                    undefined,
                    'Discover.targeting.filter.search',
                    FilterSectionEnum.COVERAGE_PROFILE,
                    true
                );
            case TargetingFiltersEnum.productType:
                return new FilterTypeCheckboxModel<string>(
                    TargetingFiltersEnum.productType,
                    'Discover.targeting.filter.productType',
                    [],
                    true,
                    undefined,
                    undefined,
                    undefined,
                    'Discover.targeting.filter.search',
                    FilterSectionEnum.COVERAGE_PROFILE
                );
            case TargetingFiltersEnum.productFrequency:
                return new FilterTypeCheckboxModel<string>(
                    TargetingFiltersEnum.productFrequency,
                    'Discover.targeting.filter.productFrequency',
                    [],
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    FilterSectionEnum.COVERAGE_PROFILE,
                    true
                );
            case TargetingFiltersEnum.targetAudience:
                return new FilterTypeCheckboxModel<string>(
                    TargetingFiltersEnum.targetAudience,
                    'Discover.targeting.filter.targetAudience',
                    [],
                    true,
                    undefined,
                    undefined,
                    undefined,
                    'Discover.targeting.filter.search',
                    FilterSectionEnum.COVERAGE_PROFILE,
                    true
                );
            case TargetingFiltersEnum.list:
                return new FilterTypeCheckboxModel<number>(
                    TargetingFiltersEnum.list,
                    'Discover.targeting.filter.list',
                    [],
                    true,
                    undefined,
                    undefined,
                    undefined,
                    'Discover.targeting.filter.search',
                    FilterSectionEnum.ORGANIZATION,
                    true
                );
            case TargetingFiltersEnum.distribution:
                return new FilterTypeCheckboxModel<number>(
                    TargetingFiltersEnum.distribution,
                    'Discover.targeting.filter.distribution',
                    [],
                    true,
                    undefined,
                    undefined,
                    undefined,
                    'Discover.targeting.filter.search',
                    FilterSectionEnum.ORGANIZATION,
                    true
                );
            case TargetingFiltersEnum.status:
                return new StatusFilterModel(
                    TargetingFiltersEnum.status,
                    'Discover.targeting.filter.status',
                    StatusFilterComponent,
                    FilterSectionEnum.ORGANIZATION
                );
            case TargetingFiltersEnum.email:
                return new FilterTypeTextModel(
                    TargetingFiltersEnum.email,
                    'Discover.targeting.filter.email',
                    [],
                    'Discover.targeting.filter.email.placeholder'
                );
            case TargetingFiltersEnum.streamContent:
                return new FilterTypeStreamContentCheckboxModel(
                    TargetingFiltersEnum.streamContent,
                    'Discover.targeting.filter.streamContent',
                    StreamContentCheckboxFilterComponent,
                    [],
                    null,
                    FilterSectionEnum.CONTENT
                );
        }
    }
}
